import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import { getRouletteResultItemsService } from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const rouletteResultsAdminContext = createContext({
  rouletteResultsItems: [],
  setRouletteResultsItems: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleGetRouletteResultsItemList: () => {},
});

const RouletteResultsAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [rouletteResultsItems, setRouletteResultsItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  // Handle Get User Satisfaction Item List Method
  const handleGetRouletteResultsItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getRouletteResultItemsService(objData);
      if (status === 200) {
        setRouletteResultsItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <rouletteResultsAdminContext.Provider
      value={{
        rouletteResultsItems,
        setRouletteResultsItems,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        handleGetRouletteResultsItemList,
      }}
    >
      {children}
    </rouletteResultsAdminContext.Provider>
  );
};

export default RouletteResultsAdminContext;
